export default "__VITE_ASSET__DAIbdIRl__"